import { Component, DestroyRef, inject, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ErrorService } from '../../../../../../../@core/utils/error.service';
import { TransactionService } from '../../../../../../core/services/TransactionService';
import { InventoryService } from '../../../../../pick-plan/services/inventory.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { faTrash, faTriangleExclamation, faXmark } from '@fortawesome/free-solid-svg-icons';

export interface RemoveInventoryData {
  /** Barcode, or e.g. "12 handling units"; shown as the subtitle. */
  label?: string;
}

export interface RemoveInventoryResult {
  result: boolean;
  transactionReasonCodeId: number;
}

@Component({
  selector: 'remove-inventory-confirmation',
  templateUrl: './remove-inventory-confirmation.component.html',
  styleUrls: ['./remove-inventory-confirmation.component.scss']
})
export class RemoveInventoryConfirmationComponent implements OnInit {

  private destroyRef = inject(DestroyRef);

  static open(dialog: MatDialog, data: RemoveInventoryData): MatDialogRef<RemoveInventoryConfirmationComponent, RemoveInventoryResult> {
    return dialog.open(RemoveInventoryConfirmationComponent, { data, width: '480px', maxWidth: '95vw' });
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: RemoveInventoryData,
    private dialog: MatDialogRef<RemoveInventoryConfirmationComponent, RemoveInventoryResult>,
    private inventoryService: InventoryService,
    private transactionService: TransactionService,
    private errorService: ErrorService
  ) { }

  public faXmark = faXmark;
  public faTrash = faTrash;
  public faTriangleExclamation = faTriangleExclamation;

  public transactionReasons = [];
  public isLoading = true;
  public transactionReasonCodeId = 0;

  ngOnInit() {
    this.transactionService.getTransactionReasonCodes().pipe(takeUntilDestroyed(this.destroyRef)).subscribe({next:x => {
      this.transactionReasons = x;
      this.isLoading = false;

    },error: err => {
      this.errorService.handleError(err);
      this.isLoading = false;
    }})

  }


  get message(): string {
    return this.data?.label ? `Remove ${this.data.label} from inventory?` : 'Remove this inventory?';
  }

  close(result: boolean) {

    this.dialog.close({
      result: result,
      transactionReasonCodeId: this.transactionReasonCodeId
    })
  }


}
